import React from "react";
import { useSelector } from "../../../../store/hooks";
import { formatNumber } from "../../../../utils/number";
import {
  getBookingAmount,
  getTotalBookingAmount,
} from "../../../../utils/bookingAmount";

export const BookingAmountCell = ({ annualValue, paymentMethodCode }) => {
  const taxonomy = useSelector((s) => s.taxonomy);
  const value = getBookingAmount(annualValue, taxonomy, paymentMethodCode);
  if (value === null) return null;
  return <span>{formatNumber(value)}</span>;
};

export const TotalBookingAmountCell = ({ row }) => {
  const taxonomy = useSelector((s) => s.taxonomy);
  const value = getTotalBookingAmount(row, taxonomy);
  if (value === null) return null;
  return <span>{formatNumber(value)}</span>;
};
